(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kpe-vinted-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kpe-review-carousel')) {
    customElements.define('kpe-review-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const track = this.querySelector('.kpe-reviews__track');
        const cards = Array.from(this.querySelectorAll('.kpe-reviews__card'));
        const previous = this.querySelector('[data-direction="-1"]');
        const next = this.querySelector('[data-direction="1"]');
        const count = this.querySelector('.kpe-reviews__count');
        if (!track || !cards.length) return;
        this.querySelector('.kpe-reviews__controls').hidden = false;
        const step = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth;
        const update = () => {
          const current = Math.min(cards.length, Math.round(track.scrollLeft / step()) + 1);
          const visible = Math.max(1, Math.floor((track.clientWidth + 20) / step()));
          const last = Math.min(cards.length, current + visible - 1);
          count.textContent = (current === last ? current : current + '–' + last) + ' / ' + cards.length;
          previous.disabled = track.scrollLeft < 2;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        };
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
          track.scrollBy({left:Number(button.dataset.direction) * step(), behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }));
        track.addEventListener('scroll', update, {passive:true});
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(track);
        update();
      }
      disconnectedCallback() { if (this.resizeObserver) this.resizeObserver.disconnect(); this.initialized = false; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
